export const HOST_PLATFORMS = {
  MOBILE: 'mobile',
  WEB: 'web',
  TENANT_PORTAL: 'tenant-portal',
} as const;

export type HostPlatform = (typeof HOST_PLATFORMS)[keyof typeof HOST_PLATFORMS];
